import { useCallback, useState } from 'react';

const useModal = (): [boolean, () => void, () => void] => {
  const [isVisible, setIsVisible] = useState(false);

  const closeModal = useCallback(() => {
    setIsVisible(false);
  }, []);

  const openModal = useCallback(() => {
    setIsVisible(true);
  }, []);

  return [isVisible, openModal, closeModal];
};

export default useModal;
